import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "order-card-item-details"
}
const _hoisted_2 = { class: "d-flex justify-space-between" }
const _hoisted_3 = { class: "font-size-12-600" }
const _hoisted_4 = {
  key: 0,
  class: "font-size-10-400 mt-2"
}
const _hoisted_5 = { class: "font-size-10-400 mt-2 font-grey-dark" }
const _hoisted_6 = {
  key: 1,
  class: "font-size-10-400 mt-2"
}
const _hoisted_7 = { class: "d-flex align-center justify-space-between mt-3" }
const _hoisted_8 = { class: "font-size-16-600" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-right pa-0" }

import {computed, ref} from 'vue';
import Icon from "@/components/Icons/Icon.vue";
import {useUserStore} from "@/api/store/user";

import OrderDetailsDialog from "@/views/OrdersComponents/OrderDetails/ProductDetails/OrderDetailsDialog.vue";
import {loadPanelData} from "@/views/ShopComponents/ItemComponents/PanelDataForSupplier";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCartProductDetails',
  props: {
  item: {
    type: Object,
  },

  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['delete'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const userStore = useUserStore();

const props = __props;

const showMore = ref(false);

const toggleText = () => {
  showMore.value = !showMore.value;
};

const getTitle = computed(() => {
  if (props.item?.product) {
    return props.item.product.name;
  }

  return props.item?.name;
})

const getImage = computed(() => {
  if (props.item?.product && props.item?.product?.images !== undefined) {
    return props.item?.product?.images[0]?.full ?? null;
  }

  return null;
})

const getIcon = computed(() => {
  const type = props.item.product?.type ?? null;

  if (type === 'clinic_product' || type === 'supplement' || type === 'product') {
    return 'product-icon';
  }

  return null;
})

const getPrice = computed(() => {
  return `${props.item.currency}${(props.item.product?.price_retail * props.item.quantity).toFixed(2)}` ?? '';
})

const getBrandName = computed(() => {
  if (props.item?.product && props.item?.product?.brand) {
    return `(${props.item?.product?.brand?.name})`;
  }

  return '';
})

const getSku = computed(() => {
  if (props.item?.product) {
    return props.item.product.sku;
  }

  return '';
})

const isShipping = computed(() => {
  return props.item.product && props.item.product.type === 'shipping_method';
})

const getSupplierName = computed(() => {
  if (props.item.supplier) {
    return props.item?.supplier?.name ?? null;
  }

  return userStore.user.clinic.name ?? null;
})


const getAttributesForClinicOrSupplier = computed(() => {
  if (getSupplierName.value === 'Natural Dispensary') {
    return loadPanelData(props.item?.product)
  }

  return props.item?.product?.attributes;
})

return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (!isShipping.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (getImage.value)
          ? (_openBlock(), _createBlock(_component_v_sheet, {
              key: 0,
              class: "logo-container m-0"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  style: _normalizeStyle({backgroundImage: `url(${getImage.value})`}),
                  class: "logo-container__image"
                }, null, 4)
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_sheet, {
              key: 1,
              class: _normalizeClass([{'secondary-background-button-color': !__props.item?.supplier }, "icon-container"])
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, { icon: getIcon.value }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["class"])),
        _createVNode(_component_v_card_text, { class: "card-description pa-0" }, {
          default: _withCtx(() => [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_3, _toDisplayString(getTitle.value), 1),
                (getBrandName.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(getBrandName.value), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_5, _toDisplayString(getSku.value), 1),
                (getSupplierName.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Supplier"))
                  : _createCommentVNode("", true),
                (getSupplierName.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 2,
                      class: _normalizeClass([{'secondary-background-button-color': !__props.item?.supplier }, "font-size-10-600 mt-2 supplier font-grey-dark"])
                    }, _toDisplayString(getSupplierName.value), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass([{'disabled': __props.disabled}, "text-right font-size-16-600 pt-0"]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('delete')))
              }, [
                _createElementVNode("p", null, [
                  _createVNode(Icon, { icon: "trash-icon" })
                ])
              ], 2)
            ]),
            _createElementVNode("section", _hoisted_7, [
              _renderSlot(_ctx.$slots, "default"),
              _createElementVNode("p", _hoisted_8, _toDisplayString(getPrice.value), 1)
            ]),
            (getAttributesForClinicOrSupplier.value?.length > 0)
              ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_v_btn, {
                      ripple: false,
                      class: "primary-underline-button text-capitalize font-size-12-600 pa-0",
                      variant: "plain",
                      onClick: toggleText
                    }, {
                      default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Show More ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _createVNode(OrderDetailsDialog, {
                    modelValue: showMore.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showMore).value = $event)),
                    attributes: getAttributesForClinicOrSupplier.value,
                    "is-supplier": getSupplierName.value === 'Natural Dispensary'
                  }, null, 8, ["modelValue", "attributes", "is-supplier"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ]))
    : _createCommentVNode("", true)
}
}

})